import { Component, OnInit } from '@angular/core';
import { SelectItem } from 'libraries/SelectItem';
import { SignInfo } from 'domain-models/SignInfo';
import { SignInfoService } from 'services/sign-info/sign-info.service';
import { AuthService } from 'services/auth/auth.service';
import { WeightStationService } from 'services/weight-station/weight-station.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Helper } from 'libraries/Helper';
import { environment } from 'environments/environment';

declare var $: any;

@Component({
	selector: 'app-weight-station-control',
	templateUrl: './weight-station-control.component.html',
	styleUrls: ['./weight-station-control.component.css']
})
export class WeightStationControlComponent implements OnInit {
	FullDetail: boolean = false;
	signInfoDropdownList: Array<SelectItem> = new Array<SelectItem>(); //List used to populate the multi-select-component
	selectedSignInfo: Array<SignInfo> = new Array();
	signInfoList: Array<SignInfo> = new Array(); //Used to save the value you get from http request, and to populate the dropdown
	messageDropdownList: Array<SelectItem> = new Array<SelectItem>(); //List of possible messages open/close/empty
	selectedMessage: string;

	constructor(
		private signInfoService: SignInfoService,
		private authService: AuthService,
		private weightStationService: WeightStationService,
		private route: ActivatedRoute,
		private router: Router
	) {
		this.signInfoDropdownList = [];
		this.messageDropdownList = [
			{ label: 'OPEN', value: 'OPEN' },
			{ label: 'CLOSED', value: 'CLOSED' },
			{ label: 'CLEAR', value: '' }
		];
		this.selectedMessage = this.messageDropdownList[0].value;
	}

	async ngOnInit() {
		this.authService.updateLogStatus();

		let canWrite = await this.authService.checkWriteAccess();
		if (!canWrite) {
			return;
		}
		this.signInfoService
			.getByValue('full', this.authService.currentUser.username)
			.subscribe((result) => {
				this.signInfoList = result;
				this.signInfoList.forEach((element) => {
					if (element.DeviceTypeNameId == environment.deviceTypeNameIds.weighStation) {
						//weight station sign
						this.signInfoDropdownList.push({
							label: element.Name,
							value: element
						});
					}
				});
				this.route.queryParams.subscribe((params) => {
					let ids = params['ids'];
					if (ids) {
						//console.log(ids);
						let selectedSigns = this.signInfoList.filter((s) => {
							return ids.some((i) => i == s.Id);
						});
						this.selectedSignInfo = selectedSigns;
						this.selectedMessage = selectedSigns[0].CurrentMessage;
					}
				});
			});
	}
	isMobile() {
		if ($(window).width() > 991) {
			return false;
		}
		return true;
	}

	updateSelectedLocations(signInfos: SignInfo[]) {
		try {
		} catch (ex) {
			console.error(ex);
		}
	}

	postMessage() {
		// alert("post works")
		this.weightStationService
			.postMessage(this.selectedSignInfo.map((sI) => sI.Id) as any, this.selectedMessage)
			.subscribe((res) => {
				console.log(res);
				this.navigateToOverviewOnSucced('Signs succesfully updated');
			});
	}

	navigateToOverviewOnSucced(message: string) {
		Helper.alert(message, 2);
		let group = this.route.snapshot.queryParams['redirectGroup'];
		console.log('GROUP: ' + group);
		if (group) {
			this.router.navigate(['/display'], {
				queryParams: { redirectGroup: group }
			});
		} else {
			this.router.navigate(['/display']);
		}
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/weight-station-control/weight-station-control.component.ts